import type { FileReviewAnchor, FileReviewAnchorKind, FileReviewDocumentKind } from './types';

export interface FileReviewAnchorAdapter<TSelection = unknown> {
  documentType: FileReviewDocumentKind;
  formatQuote(anchor: FileReviewAnchor): string;
  selectionToAnchorPayload(selection: TSelection): unknown | null;
  navigateToAnchor(anchor: FileReviewAnchor): void;
}

export function findAnchorById(
  anchors: FileReviewAnchor[],
  anchorId: string | null | undefined
): FileReviewAnchor | undefined {
  if (!anchorId) return undefined;
  return anchors.find((a) => a.id === anchorId);
}

export function anchorKindForMessage(
  anchors: FileReviewAnchor[],
  anchorId: string | null | undefined
): FileReviewAnchorKind | null {
  return findAnchorById(anchors, anchorId)?.kind ?? null;
}
